import React from "react";
import { Helmet } from "react-helmet";
import Benefits from "../components/Borrower/Benefits";
import Featured from "../components/Borrower/Featured";
import Layout from "../components/Borrower/Layout";
import Message from "../components/Borrower/Message";
import PersonalLoan from "../components/Borrower/PersonalLoan";
import Promises from "../components/Borrower/Promises";
import RatingAndReviews from "../components/Borrower/RatingAndReviews";
import Security from "../components/Borrower/Security";

const OurLoans = ({ location }) => {
  return (
    <>
      <Helmet>
        <title>Borrower | Niro</title>
      </Helmet>
      <Layout location={location}>
        <Message />
        <Benefits />
        <PersonalLoan/>
        <Promises />
        <Security />
        <RatingAndReviews />
        <Featured />
      </Layout>
    </>
  );
};

export default OurLoans;
